<template>
  <div
    class="change-partner-container"
    :class="classes"
  >
    <search-bar
      v-if="changeFavourite"
      :style="{ paddingTop: '10px' }"
    />
    <div class="service-stations-wrapper">
      <add-partner
        :show-button="false"
        v-if="!favouritePartner && !$route.path.includes('no_auth')"
      />
      <service-station-block
        v-if="!changeFavourite && selectedPartner && selectedPartner.isActive"
        class="change-partner is-chosen"
        :service-station="selectedPartner"
        :show-details="true"
        :show-fav-label="true"
        :set-favourite="changeFavourite"
        :with-slot="true"
        :set-order="true"
      >
        <standard-button
          text="Wybrano"
          v-if="!changeFavourite"
          background-color="white"
          class="fluid"
          class-type="secondary"
          @buttonClick="onClick(selectedPartner)"
          text-color="black"
        />
      </service-station-block>
      <service-station-block
        v-for="(serviceStation, index) in serviceStations"
        :key="index"
        v-if="serviceStation.isActive"
        class="change-partner"
        :service-station="serviceStation"
        :show-details="true"
        :show-fav-label="true"
        :set-favourite="changeFavourite"
        :with-slot="true"
        :set-order="true"
      >
        <standard-button
          text="Wybierz"
          class="fluid"
          v-if="!changeFavourite"
          :background-color="thirdColor"
          @buttonClick="onClick(serviceStation)"
          text-color="white"
        />
      </service-station-block>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StandardButton from '~/StandardButton';
import ServiceStationBlock from '~/ServiceStationBlock';
import SearchBar from '~/SearchBar';
import AddPartner from '~/AddPartner';

export default {
  props: {
    partners: {
      type: Array,
      default: () => [],
    },
    changeFavourite: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mounted: false,
    };
  },
  components: {
    StandardButton,
    ServiceStationBlock,
    SearchBar,
    AddPartner,
  },
  computed: {
    ...mapGetters({
      buttonColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
      filteredStations: 'serviceStations/getFiltered',
      favouritePartner: 'user/getFavouritePartner',
      registeredVisit: 'visit/registered',
      selectedPartner: 'visit/selectedPartner',
    }),
    serviceStations() {
      return this.changeFavourite ? this.filteredStations : this.partners;
    },
  },
  methods: {
    ...mapActions({
      selectPartner: 'visit/setSelectedPartner',
      fetchAvailableDates: 'visit/fetchAvailableDates',
      closeModal: 'modal/closeModal',
    }),
    onClick(serviceStation) {
      const isEdit = this.$route.path.includes('edit');
      const visitID = isEdit ? this.registeredVisit.id : null;
      this.selectPartner(serviceStation);

      this.fetchAvailableDates({ partnerID: serviceStation.id, visitID });
      this.closeModal();
    },
  },
};
</script>
